export default __webpack_public_path__ + "0ee1a08ce26012301afe2d4833d96a03.jpg";